import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { usePublicCustomFieldsPanel } from "~/components/PublicBoard/components/PublicBoardCustomFieldsPanelContent/hooks/usePublicCustomFieldsPanel";
import { BoardBlurbCustomFields } from "~/components/Workspace/BoardHeader/BoardCrumbs/BoardBlurbCustomFields";
import { usePublicBoardCustomFieldsData } from "~/swr-hooks/customFields/usePublicBoardCustomFieldsData";
export const PublicBoardHeaderCustomFields = /*#__PURE__*/ memo(()=>{
    const { data: boardCustomFields } = usePublicBoardCustomFieldsData();
    const { togglePanel } = usePublicCustomFieldsPanel();
    return /*#__PURE__*/ _jsx(BoardBlurbCustomFields, {
        customFields: boardCustomFields === null || boardCustomFields === void 0 ? void 0 : boardCustomFields.data,
        onPanelClick: togglePanel
    });
});
PublicBoardHeaderCustomFields.displayName = "PublicBoardHeaderCustomFields";
